import clsx from "clsx"
import { Progress } from "@/components/ui/progress"

function ProgressBar({
  completedCount,
  totalCount,
  progressPercentage,
}: {
  completedCount: number
  totalCount: number
  progressPercentage: number
}) {

  const color = progressPercentage < 25 ? 'text-red-500' : progressPercentage < 100 ? 'text-orange-500' : 'text-green-500'
  return (
    <div className='flex flex-col pt-4'>
    <div className='flex justify-between mb-2'>
      <div className={`text-lg font-semibold ${color}`}>
        {completedCount} of {totalCount} tasks completed
      </div>
      <div className={clsx(`font-bold  dark:text-blue-400`, color)}>
        {progressPercentage}%
      </div>
    </div>
    <Progress value={progressPercentage} className="h-3" />
  </div>
  )
}

export default ProgressBar